(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["artwork-filters"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', event => {
  const link = event.target.closest('[data-artwork-filters] a');
  if (!link) return;
  const target = new URL(link.href, location.origin);
  const current = new URL(location.href);
  for (const key of ['sort_by', 'preview_theme_id']) {
    if (current.searchParams.has(key)) target.searchParams.set(key, current.searchParams.get(key));
  }
  target.searchParams.delete('page');
  link.href = target.href;
});
  } catch(e) { console.error(e); }
})();

})();
